import { render } from "./BoardGameDetailPage.vue?vue&type=template&id=dc96487a&scoped=true"
import script from "./BoardGameDetailPage.vue?vue&type=script&lang=js"
export * from "./BoardGameDetailPage.vue?vue&type=script&lang=js"

import "./BoardGameDetailPage.vue?vue&type=style&index=0&id=dc96487a&scoped=true&lang=css"
import "./BoardGameDetailPage.vue?vue&type=style&index=1&id=dc96487a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc96487a"]])

export default __exports__